/*
 DashBoardEntity  |  ClientType  |  ClientSubType  |
 ---------------------------------------------------
 Fabricator       |  Fabricator  |  null           |
 Store            |  Fabricator  |  Store          |
 Employee         |  Customer    |  null           |
 Customer         |  Client      |  null           |
 */

export const getInfoByClientType = (clientType, clientSubType, id = null) => {
  const prefix = id ? "account.title.edit" : "account.title.add";
  switch (true) {
    case clientType === 'Fabricator' && !clientSubType:
      return {
        headerText: "account.title.fabricator",
        url: 'fabricators',
        entityType: 'fabricator',
        prefix
      };
    case clientType === 'Fabricator' && clientSubType === 'Store':
      return {
        headerText: "account.title.store",
        url: 'stores',
        entityType: 'store',
        prefix
      };
    case clientType === 'Client' && !clientSubType:
      return {
        headerText: "account.title.customer",
        url: 'customers',
        entityType: 'customer',
        prefix
      };
    case clientType === 'Customer':
      return {
        headerText: "account.title.employee",
        url: 'employees',
        entityType: 'employee',
        prefix
      };
    default:
      return {
        headerText: "account.title.customer",
        url: 'users',
        prefix
      };
  }
};

export const getMasterProfile = (store) => {
  const {newaccount} = store;
  let masterProfile = null;
  if (newaccount.assignedMasterProfile && newaccount.assignedMasterProfile.id) {
    masterProfile = newaccount.assignedMasterProfile;
  }
  if (!masterProfile && newaccount.customerInfo.masterProfile && newaccount.customerInfo.masterProfile.id) {
    masterProfile = newaccount.customerInfo.masterProfile;
  }
  return masterProfile || {id: 0, isMaster: false};
};
